import type { RiskGapModel } from '@ctw/shared/api/fhir/models/risk-gap';
import type { OverviewCardDataProps } from '@ctw/shared/content/overview/resource-overview-card';
import { ResourceOverviewCard } from '@ctw/shared/content/overview/resource-overview-card';
import { PatientRiskGapsResourceTableRow } from '@ctw/shared/content/patient-risk-gaps/components/resource-table';
import { buildPatientRiskGapsColumnsV2 } from '@ctw/shared/content/patient-risk-gaps/helpers/columns-v2';
import { tw } from '@ctw/shared/utils/tailwind';
import { faStarExclamation } from '@fortawesome/pro-solid-svg-icons';

const RISK_GAP_OVERVIEW_COLUMNS = buildPatientRiskGapsColumnsV2();

export type PatientRiskGapOverviewCardProps = OverviewCardDataProps<RiskGapModel>;

/**
 * Presentational risk capture overview card. Renders the pre-filtered/sorted
 * list it is handed; data fetching lives in `usePatientRiskGapsOverviewData`.
 * Row-click behavior is supplied by the container via `onRowClick`.
 */
export const PatientRiskGapOverviewCard = ({
  data,
  isLoading,
  emptyState,
  footerCTA,
  onRowClick,
}: PatientRiskGapOverviewCardProps) => (
  <ResourceOverviewCard
    onRowClick={onRowClick}
    data={data}
    emptyState={emptyState}
    footerCTA={footerCTA}
    title="Risk Capture"
    helpText="Risk suspecting and recapture opportunities for the current calendar year"
    loading={isLoading}
    headerIcon={faStarExclamation}
    testId="risk-gaps-overview"
    rowClassName={tw`p-0`}
    renderResource={(record: RiskGapModel, index: number) => (
      <PatientRiskGapsResourceTableRow
        variant={'active'}
        title={'overview'}
        record={record}
        rowIndex={index}
        displayedRecords={data}
        // The ResourceOverviewCard provides its own background hover.
        hasBackgroundHover={false}
        shouldMinimize={true}
        columns={RISK_GAP_OVERVIEW_COLUMNS}
      />
    )}
  />
);
